/**
 * Destination Card UI Components
 */

// Destination card (for sections/communities with images)
export {DestinationCard} from "./destination-card";
export type {DestinationCardProps} from "./destination-card";
